(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const money = (cents) => {
    const fmt = (window.GlassTheme && window.GlassTheme.moneyFormat) || '${{amount}}';
    let amt = (cents / 100).toFixed(2);
    if (amt.endsWith('.00')) amt = amt.slice(0, -3);
    return fmt.replace(/{{[^}]*}}/, amt);
  };
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const thumb = (u) => u + (u.includes('?') ? '&' : '?') + 'width=120';

  /* light / dark toggle */
  $$('[data-theme-toggle]').forEach((b) => b.addEventListener('click', () => {
    const light = document.documentElement.classList.toggle('theme-light');
    try { localStorage.setItem('cpv-theme', light ? 'light' : 'dark'); } catch (e) {}
  }));

  /* specular highlight follows the pointer */
  document.addEventListener('pointermove', (e) => {
    const el = e.target.closest && e.target.closest('.glass');
    if (!el) return;
    const r = el.getBoundingClientRect();
    el.style.setProperty('--mx', (e.clientX - r.left) + 'px');
    el.style.setProperty('--my', (e.clientY - r.top) + 'px');
  });

  /* card tilt */
  if (matchMedia('(pointer:fine)').matches && !reduce) {
    document.addEventListener('pointermove', (e) => {
      const c = e.target.closest && e.target.closest('.card');
      if (!c) return;
      const r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      c.style.transform = `perspective(900px) rotateY(${x * 6}deg) rotateX(${-y * 6}deg) translateY(-4px)`;
    });
    document.addEventListener('pointerout', (e) => {
      const c = e.target.closest && e.target.closest('.card');
      if (c && !c.contains(e.relatedTarget)) c.style.transform = '';
    });
  }

  /* hero timeline: waveform + timecode */
  $$('.wave').forEach((w) => {
    w.innerHTML = Array.from({ length: 42 }, (_, k) => `<i style="height:${30 + Math.abs(Math.sin(k * .7)) * 70}%;animation-delay:${-(k % 7) * .17}s"></i>`).join('');
  });
  const tc = $('.tc');
  if (tc && !reduce) {
    const t0 = performance.now();
    const tick = (now) => {
      const s = ((now - t0) / 1000) % 7, f = Math.floor((s % 1) * 30);
      tc.textContent = `00:00:${String(Math.floor(s)).padStart(2, '0')}:${String(f).padStart(2, '0')}`;
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  /* product gallery thumbs */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('.thumbs button');
    if (!t) return;
    const main = t.closest('.pdp-media').querySelector('.main img');
    main.src = t.dataset.src; main.srcset = '';
    $$('button', t.parentNode).forEach((b) => b.setAttribute('aria-current', b === t));
  });

  /* collection filter chips */
  const filter = (root, f) => {
    if (!root) return;
    $$('.chip[data-f]', root).forEach((b) => b.setAttribute('aria-pressed', b.dataset.f === f));
    $$('.card[data-cols]', root).forEach((c) => c.classList.toggle('hide', f !== 'all' && !c.dataset.cols.split(' ').includes(f)));
  };
  document.addEventListener('click', (e) => {
    const chip = e.target.closest('.chip[data-f]');
    if (chip) filter(chip.closest('[data-filter-root]'), chip.dataset.f);
    const jump = e.target.closest('[data-jump]');
    if (jump) filter($('[data-filter-root]'), jump.dataset.jump);
  });

  /* mobile menu */
  const mt = $('.menu-toggle');
  if (mt) mt.addEventListener('click', () => {
    const m = $('#MobileMenu'); const on = !m.classList.contains('on');
    m.classList.toggle('on', on); mt.setAttribute('aria-expanded', on);
  });

  /* cart drawer */
  const drawer = $('#CartDrawer'), scrim = $('#CartScrim');
  if (!drawer) return;
  const openCart = (o) => {
    drawer.classList.toggle('on', o); scrim.classList.toggle('on', o);
    drawer.setAttribute('aria-hidden', !o);
    if (o) $('.x', drawer).focus();
  };
  const render = (cart) => {
    $('#CartLines').innerHTML = cart.items.length ? cart.items.map((i) => `
      <div class="line">
        ${i.image ? `<img src="${thumb(i.image)}" alt="" width="52" height="52" loading="lazy">` : '<span></span>'}
        <div><a href="${i.url}" style="text-decoration:none;font-weight:600">${esc(i.product_title)}</a><div style="color:var(--muted)">${i.quantity > 1 ? i.quantity + ' × ' : ''}${money(i.final_price)}</div></div>
        <button class="rm" data-rm="${i.key}">Remove</button>
      </div>`).join('') : `<p class="empty">${esc(drawer.dataset.empty)}</p>`;
    $('#CartTotal').textContent = money(cart.total_price);
    $('#CartCheckout').disabled = !cart.items.length;
    const ids = cart.items.map((i) => String(i.variant_id));
    const megaIn = drawer.dataset.mega && ids.includes(drawer.dataset.mega);
    const indiv = cart.items.filter((i) => String(i.variant_id) !== drawer.dataset.mega).reduce((a, i) => a + i.final_line_price, 0);
    $('#CartHint').textContent = !megaIn && drawer.dataset.megaPrice && indiv >= +drawer.dataset.megaPrice ? drawer.dataset.hint : '';
    $$('.cart-count').forEach((c) => { c.textContent = cart.item_count; c.classList.toggle('on', cart.item_count > 0); });
    $$('.add[data-variant]').forEach((b) => {
      const on = ids.includes(b.dataset.variant);
      b.classList.toggle('done', on); b.textContent = on ? b.dataset.added : b.dataset.label;
    });
  };
  const refresh = () => fetch('/cart.js').then((r) => r.json()).then(render).catch(() => {});
  const bump = () => $$('[data-cart-open]').forEach((b) => { b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump'); });
  const post = (url, body) => fetch(url, { method: 'POST', headers: { Accept: 'application/json' }, body }).then((r) => r.json().then((j) => ({ ok: r.ok, j })));

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]'); if (btn) btn.disabled = true;
    const msg = form.querySelector('.form-msg');
    post('/cart/add.js', new FormData(form)).then(({ ok, j }) => {
      if (!ok) { if (msg) msg.textContent = j.description || j.message || 'Could not add to cart.'; return; }
      if (msg) msg.textContent = '';
      bump(); return refresh().then(() => openCart(true));
    }).finally(() => { if (btn) btn.disabled = false; });
  });
  document.addEventListener('click', (e) => {
    const add = e.target.closest('.add[data-variant]');
    if (add) {
      e.preventDefault();
      if (add.classList.contains('done')) { refresh(); openCart(true); return; }
      const fd = new FormData(); fd.append('id', add.dataset.variant); fd.append('quantity', '1');
      add.disabled = true;
      post('/cart/add.js', fd).then(() => { bump(); return refresh(); }).finally(() => { add.disabled = false; });
      return;
    }
    const rm = e.target.closest('[data-rm]');
    if (rm) fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: rm.dataset.rm, quantity: 0 }) }).then((r) => r.json()).then(render);
    const op = e.target.closest('[data-cart-open]');
    if (op && !document.body.classList.contains('template-cart')) { e.preventDefault(); refresh(); openCart(true); }
    if (e.target.closest('[data-cart-close]')) openCart(false);
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') openCart(false); });
  refresh();
})();